import { useMutation } from '@apollo/client';

import { useCurrentEventQuery } from '../../event/hooks/useCurrentEventQuery';
import { useToast } from '../../toast/Toast.context';
import {
  LEAVE_CARPOOL_TRIP,
  LeaveCarpoolTripMutation,
  LeaveCarpoolTripMutationVariables,
} from '../graphql/mutation/leaveCarpoolTripMutation.graphql';
import {
  CARPOOL_TRIPS,
  CarpoolTripsQueryVariables,
} from '../graphql/query/carpoolTripsQuery.graphql';

export const useLeaveCarpoolTripMutation = () => {
  const { data: currentEventData } = useCurrentEventQuery();
  const { showToast } = useToast();
  const [mutate] = useMutation<
    LeaveCarpoolTripMutation,
    LeaveCarpoolTripMutationVariables
  >(LEAVE_CARPOOL_TRIP);

  const leaveCarpoolTrip = async (tripId: string) => {
    const eventId = currentEventData?.currentEvent?.id;
    if (!eventId) {
      return;
    }

    await mutate({
      variables: { tripId },
      refetchQueries: [
        {
          query: CARPOOL_TRIPS,
          variables: { eventId } satisfies CarpoolTripsQueryVariables,
        },
      ],
    });

    showToast({
      type: 'success',
      message: 'Trajet quitté.',
    });
  };

  return { leaveCarpoolTrip };
};
